import { RefreshCw } from "lucide-react";
import { useRefreshBids } from "@/lib/bids";

/** Pulls in bids placed on the website since the list last loaded. */
export default function RefreshBidsButton({ className = "" }) {
  const { refresh, refreshing } = useRefreshBids();
  return (
    <button
      type="button"
      onClick={refresh}
      disabled={refreshing}
      title="Check the website for new bids"
      data-testid="bids-refresh"
      className={`text-xs bg-secondary rounded-md px-3 py-1.5 hover:bg-primary hover:text-primary-foreground disabled:opacity-60 flex items-center gap-1.5 font-mono uppercase tracking-widest ${className}`}
    >
      <RefreshCw className={`w-3 h-3 ${refreshing ? "animate-spin" : ""}`} />
      Refresh
    </button>
  );
}
